module.exports = __webpack_public_path__ + "img/Copy.deda74f4.svg";